




































import {Component, Prop, Vue} from 'vue-property-decorator'
import NavbarWalletStatusIcon from '@/components/navbar/NavbarWalletStatusIcon.vue'
import {WalletSessionSummary} from '@/model/wallets/types/WalletSessionSummary'

@Component({
  components: {
    NavbarWalletStatusIcon,
  },
})
export default class NavbarWalletSessionConnectedButton extends Vue {
  @Prop({type: Array, required: true}) sessions!: WalletSessionSummary[]
  @Prop({type: Boolean, required: true}) dropdownIsOpen!: boolean
  @Prop({type: Boolean, required: true}) showsFirstSessionHeader!: boolean

  get firstSession(): WalletSessionSummary {
    return this.sessions[0]
  }
}
